//
//
//
//
import * as echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'barChart',
  props: ['chart'],
  data: function data() {
    return {
      image: ''
    };
  },
  methods: {
    initBarChart: function initBarChart(data, columnsData, val, resolve) {
      var _this = this;

      var title = val;
      var xData = data.xData;
      var arrs = [];
      var legendData = [];

      for (var i = 0; i < columnsData.length; i++) {
        if (columnsData[i].siteName != '汇总') {
          arrs.push({
            name: columnsData[i].title,
            type: 'bar',
            data: columnsData[i].data
          });
          legendData.push(columnsData[i].title);
        }
      }

      var option = {
        title: {
          text: "".concat(title),
          top: 'auto',
          x: 'center',
          textStyle: {
            fontSize: 18,
            color: 'black'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: legendData,
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisTick: {
            show: false
          },
          data: xData,
          nameLocation: 'center',
          nameTextStyle: {
            width: '100px'
          }
        }],
        yAxis: [{
          type: 'value'
        }],
        series: arrs
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option, true);
      setTimeout(function () {
        _this.image = myChart.getDataURL();

        _this.$emit('getImage', _this.image, val);

        resolve('111');
      }, 1000);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};